import ukrCitiesJson from './data/ukr-nuke-cities.json'
import {Geometry, FeatureCollection} from 'geojson'
import {keys} from 'remeda'

const cityNames = ['Mariupol', 'Sievierodonetsk', 'Melitopol', 'Chaplynka'] as const
type CityName = (typeof cityNames)[number]
type CityProperties = {name: CityName}
export const cityData = (ukrCitiesJson as FeatureCollection<Geometry, CityProperties>).features.filter(({properties}) =>
  cityNames.includes(properties.name)
)

export const shapeCfg = {
  'Autonomous Republic of Crimea': {words: ['Crimea']},
  'Donetsk Oblast': null,
  'Luhansk Oblast': null,
  'Zaporizhia Oblast': {words: ['Zaporizhia', 'Zaporizhzhia']},
  'Kherson Oblast': null,
  Ukraine: {words: ['in Ukraine']}
}

type ShapeName = keyof typeof shapeCfg
type ShapeProperty = {shapeName: ShapeName; Level: string}

export const asFeatureCollection = (
  features: FeatureCollection<Geometry>['features']
): FeatureCollection<Geometry> => ({
  type: 'FeatureCollection',
  features
})

export const shapeData = async () =>
  ((await import('./data/ukr-nuke-shapes.json')) as FeatureCollection<Geometry, ShapeProperty>).features

export const textMatchesShape = (causesText: string, shapeName: ShapeName) => {
  const words = shapeCfg[shapeName]?.words ?? [shapeName.replace(' Oblast', '')]
  return words.some(w => causesText?.match(new RegExp(`\\b${w}\\b`, 'i')))
}

export const textMatchesCity = (causesText: string, name: CityName) =>
  causesText?.match(new RegExp(`\\b${name}\\b`, 'i')) ? true : false

export const textInMap = (texts: string[]) =>
  texts.some(
    t =>
      (keys(shapeCfg) as ShapeName[])
        .filter(s => !['Ukraine', 'Autonomous Republic of Crimea'].includes(s))
        .some(s => textMatchesShape(t, s)) || cityNames.some(c => textMatchesCity(t, c as CityName))
  )
